module.exports = __webpack_public_path__ + "static/media/bg-palm.986c45ae.svg";